import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { SharedService } from '../../_services/shared.service';
import { AuthService } from '../../_services/auth.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ResponsiveMode } from '../../enum/responsiveModes';
import { fromEvent, map, Observable, shareReplay } from 'rxjs';
import Utils from '../../_utils/utils';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-offer-confirmation-validation-sent',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    NgxSpinnerModule,
  ],
  templateUrl: './offer-confirmation-validation-sent.component.html',
  styleUrl: './offer-confirmation-validation-sent.component.css'
})
export class OfferConfirmationValidationSentComponent implements OnInit, AfterViewInit  {

    private propertyId: string = '';
    private offerAliasId: string = '';
    viewMode: string = ResponsiveMode.horizontal;
    
    offerError: boolean = false;
    offerRefresh: boolean = false;
    
    @ViewChild('cardButton') button: any;
    tokenButton$!: Observable<any>;

    resendButtonEnabled: boolean = true; 

    constructor(public sharedService: SharedService,
                private authService: AuthService,
                private router: Router,
                private route: ActivatedRoute) {                
    }

  ngOnInit(): void {
    if(localStorage.getItem('offerError')){
      if(localStorage.getItem('offerError') === 'true' && localStorage.getItem('error_offer_alias_id') === this.offerAliasId){
        this.offerError = true;
        this.router.navigate(['/offerNotAvailable']);
      } else {
        this.offerError = false;
        localStorage.setItem('offerError', 'false');
        localStorage.setItem('error_offer_alias_id', '');
      }
    }
    this.propertyId = this.route.snapshot.paramMap.get('prop_id') ? this.route.snapshot.paramMap.get('prop_id') as string : '';
    this.offerAliasId = this.route.snapshot.paramMap.get('alias_id') ? this.route.snapshot.paramMap.get('alias_id') as string : '';    
  }

  ngAfterViewInit(): void {
    
    this.tokenButton$ = fromEvent(this.button.nativeElement, 'click').pipe(
      shareReplay(1),
      map(() => this.authService.requestUpgradeConfirmationValidation(this.offerAliasId, 
                                                                      this.propertyId,
                                                                      this.sharedService.offer.offer_id,
                                                                      this.sharedService.offer.base_room_category_name,
                                                                      this.sharedService.offer.bar_price).subscribe())
    );
    this.tokenButton$.subscribe();
    
  }

  ngOnDestroy(): void {
    this.offerError = false;
    localStorage.setItem('offerError', 'false');
    localStorage.setItem('error_offer_alias_id', '');
  }

  responsiveStyle(styleObj: {[key: string]: string}): {[key: string]: boolean} {   
    return Utils.responsiveStyle(this.viewMode, styleObj);
  }

}
